// extracted by mini-css-extract-plugin
export default {"root":"_3lIAh","small":"_2GOTT","normal":"_2Mkh4"};